import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import Aura from '@primeng/themes/aura'
import { providePrimeNG } from 'primeng/config'
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { ButtonModule } from 'primeng/button';
import { FrameComponent } from './frame/frame.component';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { realmInterceptor } from './interceptors/x-realm.interceptor';
import { TooltipModule } from 'primeng/tooltip';
import { PedidosModule } from './modulos/pedidos/pedidos.module';
import { AutoRefreshTokenService, provideKeycloak, UserActivityService, withAutoRefreshToken } from 'keycloak-angular'
import { environment } from '@environments/environment';
import { NameInitialsPipe } from '@shared/pipes/name-initials/name-initials.pipe';
import { ErpAvatarComponent } from './frame/components/erp-avatar/erp-avatar.component';
import { ErpSidebarItemComponent } from './frame/components/erp-sidebar-item/erp-sidebar-item.component';
import { ErpSidebarComponent } from './frame/components/erp-sidebar/erp-sidebar.component';

const PT_BR_CALENDAR = {
  dayNames: ["Domingo","Segunda-feira","Terça-feira","Quarta-feira","Quinta-feira","Sexta-feira","Sábado"],
  dayNamesShort: ["Dom","Seg","Ter","Qua","Qui","Sex","Sáb"],
  dayNamesMin: ["D","S","T","Q","Q","S","S"],
  monthNames: ["Janeiro","Fevereiro","Março","Abril","Maio","Junho","Julho","Agosto","Setembro","Outubro","Novembro","Dezembro"],
  monthNamesShort: ["Jan","Fev","Mar","Abr","Mai","Jun","Jul","Ago","Set","Out","Nov","Dez"],
  today: 'Hoje',
  clear: 'Limpar',
  firstDayOfWeek: 0
}

const pathSegments = window.location.pathname.split('/');
const realmFromPath = pathSegments[1]; 

@NgModule({
    declarations: [
        AppComponent,
        FrameComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        ButtonModule,
        PedidosModule,
        TooltipModule,
        NameInitialsPipe,
        ErpAvatarComponent,
        ErpSidebarComponent,
        ErpSidebarItemComponent
    ],
    providers: [
        provideAnimationsAsync(),
        provideHttpClient(
            withInterceptors(
                [
                    realmInterceptor
                ])),
        providePrimeNG({
            theme: {
                preset: Aura,
                options: {
                    darkModeSelector: '.erp-dark'
                }
            },
            translation: PT_BR_CALENDAR
        }),
        AutoRefreshTokenService, 
        UserActivityService,
        provideKeycloak({
            config: {
              url: environment.keycloak.url,
              realm: realmFromPath,
              clientId: environment.keycloak.clientId,
            },

            initOptions: {
              onLoad: 'login-required',
              silentCheckSsoRedirectUri: window.location.origin + '/assets/silent-check-sso.html',
              redirectUri: window.location.href,
              checkLoginIframe: false,
            },
            features: [
                withAutoRefreshToken({
                  onInactivityTimeout: 'logout',
                  sessionTimeout: 28800000,
                })
              ]
          }),
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
